/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

// FLOW FOR PARTNER REGISTRATION
// For new users -> First signup will be treated as simple signup, partner won't be redirected to partner platform
// Use validate web signup otp and validate sign in otp
// From above api call use its auth-code and hit https://api.buildwealthdev.in/dashboards/fetch/access-token/ with client_id and auth_code (clientId is used to let backend know which access should be granted)
// You get api key use it for all the other calls, and store api key in sessionStorage
// Continue with qna flow
// Get apiKey from sessionStorage and use it and hit https://api.buildwealthdev.in/dashboards/api/v0/mobile-redirect/?token=apiKey
// Afterwards redirect to partnerDash

import React, {useEffect, useState} from "react";
import {
  WealthyEnv,
  WealthyValidations,
  addValidArnQueryParam,
  handleApiError,
  triggerToast
} from "helpers";
import {
  getPartnerSignupApiKey,
  reSendExistingSignInOtp,
  reSendSignUpOtp,
  registerAdvisorWithCaptcha,
  requestSubscription,
  validateReferralCode,
  validateWebSignInOtp,
  validateWebSignUpOtp
} from "api";

import Form from "./Form";

import BlogForm from "./BlogForm";
import PartnerHomeForm from "./PartnerHomeForm";
import {getClickIds} from "helpers"; 

const formInputs = ["firstName", "lastName", "email", "phoneNumber"];

const FormContainer = ({
  setUserData,
  step,
  updateStep,
  isEmbedded,
  embeddedVariant = "blog",
  onOtpSuccess
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [counter, setCounter] = useState(30);
  const [isResendingOtp, setResendingOtp] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    referralCode: ""
  });
  const [isDisabled, setIsDisabled] = useState(true);
  const [otp, setOtp] = useState([]);
  const [errorText, setErrorText] = useState({
    phoneNumber: "",
    email: "",
    captcha: ""
  });
  const [selectedCountryCode, setSelectedCountryCode] = useState({
    country: "India",
    code: "(+91)"
  });
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasReferralCode, setHasReferralCode] = useState(false);
  const [referralStatus, setReferralStatus] = useState("");

  const [landingPageUrl, setLandingPageUrl] = useState();
  const [isPartnerExisting, setIsPartnerExisting] = useState(false);
  const [isSubscribing, setIsSubscribing] = useState(true);

  const [subscribeToken, setSubscribeToken] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    setLandingPageUrl(window.location.href);
  }, []);


  useEffect(() => {
    setIsDisabled(validateForm());
  }, [formData]);

  useEffect(() => {
    let timer = "";
    if (step === 2) {
      timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    } else {
      setCounter(30);
    }
    return () => clearInterval(timer);
  }, [counter, step]);

  useEffect(() => {
    if (otp.length === 5) {
      submitOtp();
    }
  }, [otp]);

  const onChangeHandler = (event) => {
    const {
      name,
      value
    } = event.target;

    if (name === "phoneNumber" && value.length > 10) {
      return;
    }

    if (name === "email") {
      if (value.length > 250) {
        return triggerToast("Email can not contain more than 250 characters");
      }
    }

    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleCountryCodeChange = (countryData) => {
    setSelectedCountryCode(countryData);
    setShowDropdown(false);
  };

  const handleReferralValidation = async () => {
    if (!formData.referralCode) {
      setReferralStatus("invalid");
      return;
    }

    try {
      setIsLoading(true);
      await validateReferralCode(formData.referralCode);
      setReferralStatus("valid");
    } catch (error) {
      setReferralStatus("invalid");
    } finally {
      setIsLoading(false);
    }
  };

  const handleReferralCheckbox = () => {
    setHasReferralCode(!hasReferralCode);
    if (!hasReferralCode) {
      setReferralStatus("");
      setFormData({
        ...formData,
        referralCode: ""
      });
    }
  };

  const validateForm = () => {
    let isFormValidated = false;
    for (const input of formInputs) {
      if (!formData[input].length > 0) {
        isFormValidated = true;
      }
    }

    return isFormValidated;
  };

  const onKeyUpHandler = (keyCode, previousElement, currentElement, nextElement) => {
    if ((keyCode === 8 || keyCode === 46) && previousElement !== -1) {
      document.getElementById(previousElement).focus();
    }

    if (currentElement.value.length) {
      document.getElementById(nextElement).focus();
    }
  };

  const handlePaste = (event) => {
    const otpInputs = Array.from(document.querySelectorAll(".otp-input"));
    const clip = event.clipboardData.getData("text");
    const pin = clip.replace(/\s/g, "");
    const ch = [...pin];
    otpInputs.forEach((el, i) => el.value = ch[i] ? ch[i] : "");
    otpInputs[pin.length - 1].focus();
    setOtp(ch);
  };

  const getUtmTags = () => {
    let utmSource;
    let utmMedium;
    let utmContent;
    let utmCampaign;
    let utmTerm;
    if (window.location.search.includes("utm")) {
      const param = new URLSearchParams(window.location.search);

      const getUtmValue = (utmTag) => {
        return param.get(utmTag) || "(none)";
      };

      utmSource = getUtmValue("utm_source");
      utmContent = getUtmValue("utm_content");
      utmCampaign = getUtmValue("utm_campaign");
      utmMedium = getUtmValue("utm_medium");
      utmTerm = getUtmValue("utm_term");
    } else {
      utmSource = "";
      utmContent = "";
      utmCampaign = "";
      utmMedium = "";
      utmTerm = "";
    }

    return {
      utmSource,
      utmMedium,
      utmContent,
      utmCampaign,
      utmTerm
    };
  };

  const ensureRecaptchaLoaded = () => {
    return new Promise((resolve) => {
      if (typeof window.grecaptcha !== "undefined") {
        resolve();
        return;
      }
      const existing = document.querySelector(`script[src*="recaptcha/api.js"]`);
      if (existing) {
        const check = setInterval(() => {
          if (typeof window.grecaptcha !== "undefined") {
            clearInterval(check);
            resolve();
          }
        }, 100);
        return;
      }
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${WealthyEnv.RECAPTCHA_SITEKEY}`;
      script.onload = () => {
        const check = setInterval(() => {
          if (typeof window.grecaptcha !== "undefined") {
            clearInterval(check);
            resolve();
          }
        }, 100);
      };
      document.head.appendChild(script);
    });
  };

  const initSubscriptionCaptcha = () => {
    ensureRecaptchaLoaded().then(() => {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(`${WealthyEnv.RECAPTCHA_SITEKEY}`, {action: "homepage"}).then(function (token) {
          setSubscribeToken(token);
        });
      });
    });
  };

  const initCaptcha = () => {
    ensureRecaptchaLoaded().then(() => {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(`${WealthyEnv.RECAPTCHA_SITEKEY}`, {action: "homepage"}).then(function (token) {
          setToken(token);
        });
      });
    });
  };

  const getFreshToken = () => {
    return ensureRecaptchaLoaded().then(() => {
      return new Promise((resolve) => {
        window.grecaptcha.ready(function () {
          window.grecaptcha.execute(`${WealthyEnv.RECAPTCHA_SITEKEY}`, {action: "homepage"}).then(resolve);
        });
      });
    });
  };

  const submitSubscribe = async () => {
    try {
      const email = formData.email;
      let subToken = subscribeToken;
      if (!subToken) {
        subToken = await getFreshToken();
        setSubscribeToken(subToken);
      }
      await requestSubscription({email, token: subToken});
      if (window?.analytics) {
        window?.analytics.track("Subscription requested", {
          category: "Money Order",
          label: "Subscription"
        });
      } else {
        console.log("analytics not set, analytics not available");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const submitForm = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);

      const isPhoneNumberValid = WealthyValidations.validateFormField.internationalPhone(formData["phoneNumber"]);
      const isEmailValid = WealthyValidations.validateFormField.email(formData["email"]);
      const isNameValid = WealthyValidations.validateFormField.name(formData["firstName"]) && WealthyValidations.validateFormField.name(formData["lastName"]);
      const trimmedFirstName = formData.firstName.trim();
      const isFirstNameEmpty = !trimmedFirstName.length > 0;
      const isFirstNameTooLong = trimmedFirstName.length > 100 || trimmedFirstName.length < 0 ? true : false;
      const trimmedLastName = formData.lastName.trim();
      const isLastNameEmpty = !trimmedLastName.length > 0;
      const isLastNameTooLong = trimmedLastName.length > 100 || trimmedLastName.length < 0 ? true : false;

      if (hasReferralCode) {
        if (!formData.referralCode) {
          triggerToast("Please enter a referral code");
          return;
        }
        if (referralStatus !== "valid") {
          triggerToast("Please enter a valid referral code");
          return;
        }
      }

      if (!isPhoneNumberValid) {
        return triggerToast("Please enter a valid phone number");
      }

      if (isFirstNameEmpty || isLastNameEmpty) {
        return triggerToast("Name can not be empty");
      }

      if (isFirstNameTooLong || isLastNameTooLong) {
        return triggerToast("Name can not exceed 100 characters");
      }

      if (!isNameValid) {
        return triggerToast("Name can only contain letters");
      }

      if (!isEmailValid) {
        return triggerToast("Please enter a valid email");
      }

      let captchaToken = token;
      if (!captchaToken) {
        try {
          captchaToken = await getFreshToken();
          setToken(captchaToken);
        } catch {
          triggerToast("Captcha Failed! Please refresh the page and try again");
          return;
        }
      }

      const utmTags = getUtmTags();
      const {extractGclidFromUrl} = getClickIds();
      const gclid = extractGclidFromUrl(landingPageUrl);

      const payload = {
        ...formData,
        phoneNumber: selectedCountryCode.code + formData.phoneNumber,
        landingPageUrl,
        adClickId: gclid,
        adClickSource: utmTags?.utmMedium || null,
        ...utmTags
      };

      delete payload.dwmLeadId;

      const dwmResponse = await registerAdvisorWithCaptcha(payload, captchaToken);

      const dwmData = dwmResponse.data;
      setIsPartnerExisting(dwmData.existing);
      window.sessionStorage.setItem("isExistingLead", dwmData.existing);
      setFormData({
        ...formData,
        dwmLeadId: dwmData.leadId
      });

      setUserData({
        ...formData
      });
      updateStep(2);
    } catch (error) {
      let message = "";

      const isError = !!error?.response?.data;
      if (isError) {
        message = error.response.data?.message;
        if (message) {
          setErrorText({
            phoneNumber: "",
            email: "",
            captcha: message
          });
          return;
        }
        message = (error.response?.data?.error);
        const email = message.email;
        const phoneNumber = message.phoneNumber;

        if ((email && email.length > 0) || (phoneNumber && phoneNumber.length > 0)) {
          setErrorText({ phoneNumber: phoneNumber || "", email: email || "", captcha: "" });
          return;
        }
      } else {
        triggerToast("Something went wrong");
      }
    } finally {
      initSubscriptionCaptcha();
      initCaptcha();
      setIsLoading(false);
    }
  };

  const getApiKey = async (authCode) => {
    try {
      const payload = {
        clientId: `${WealthyEnv.ADVISOR_CLIENT_ID}`,
        authCode
      };
      const res = await getPartnerSignupApiKey(payload);
      const apiKey = res.data?.accessToken;
      window.sessionStorage.setItem("apiKey", apiKey);
    } catch (error) {
      handleApiError(error);
    }
  };


  const submitOtp = async () => {
    try {
      setIsLoading(true);
      window.sessionStorage.setItem("leadId", formData.dwmLeadId);
      let otpResponse;
      if (isPartnerExisting) {
        otpResponse = await validateWebSignInOtp({
          otp: otp.join(""),
          leadId: formData.dwmLeadId,
          phoneNumber: formData.phoneNumber
        });
      } else {
        otpResponse = await validateWebSignUpOtp({
          otp: otp.join(""),
          leadId: formData.dwmLeadId
        });
      }
      const {data} = otpResponse;

      console.log("otpResponse", data, "arn is valid or not", data.Arn);

      // Add validArn query parameter to URL
      if (data.validArn !== undefined) {
        addValidArnQueryParam(data.validArn);
      }

      if (isSubscribing && otpResponse) {
        submitSubscribe();
      }

      if (data.authCode) {
        await getApiKey(data.authCode);
      }
      const apiKey = window.sessionStorage.getItem("apiKey");
      const isApiKeyPresent = !!apiKey;
      if (isApiKeyPresent) {
        if (isEmbedded && onOtpSuccess) {
          onOtpSuccess();
        } else {
          updateStep(3);
        }
      }
    } catch (error) {
      setOtp([]);
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onOtpChangeHandler = (event) => {
    const otpInputs = Array.from(document.querySelectorAll(".otp-input"));
    const {
      value,
      dataset: {index}
    } = event.target;

    const newOtp = otp.slice();
    newOtp[index] = value;
    setOtp(newOtp);

    const nextIndex = +index + 1;
    if (value && otpInputs[nextIndex]) {
      otpInputs[nextIndex].select();
    } else if (value && !otpInputs[nextIndex]) {
      event.target.blur();
    }
  };

  const resendOtp = async () => {
    try {
      setResendingOtp(true);
      if (isPartnerExisting) {
        await reSendExistingSignInOtp({
          phoneNumber: formData.phoneNumber
        });
      } else {
        await reSendSignUpOtp({
          leadId: formData.dwmLeadId
        });
      }

      triggerToast("OTP Resent", "success");
    } catch (error) {
      handleApiError(error);
    } finally {
      setResendingOtp(false);
      setCounter(30);
    }
  };

  const formProps = {
    counter,
    errorText,
    formData,
    hasReferralCode,
    isDisabled,
    isLoading,
    isPartnerExisting,
    isResendingOtp,
    isSubscribing,
    referralStatus,
    selectedCountryCode,
    showDropdown,
    step,
    handleCountryCodeChange,
    handlePaste,
    handleReferralCheckbox,
    handleReferralValidation,
    onChangeHandler,
    onKeyUpHandler,
    onOtpChangeHandler,
    resendOtp,
    setCounter,
    setFormData,
    setIsSubscribing,
    setResendingOtp,
    setShowDropdown,
    submitForm,
    updateStep
  };
  return (
    <>
      {isEmbedded && embeddedVariant === "partner-home" ? (
        <PartnerHomeForm {...formProps} />
      ) : isEmbedded ? (
        <BlogForm {...formProps} isEmbedded={isEmbedded} />
      ) : (
        <Form {...formProps} />
      )}
    </>
  );
};

export default FormContainer;
